import { Component, Inject, Input } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { IFlujoLightTX, IRegcheqDatasource } from 'src/app/interface/IFlujoLightTx';
import { UtilsService } from 'src/app/shared/services/utils.service';

@Component({
    selector: 'app-salfa-info-regcheq',
    templateUrl: './salfa-info-regcheq.component.html',
    styleUrls: ['./salfa-info-regcheq.component.scss']
})
export class SalfaInfoRegcheqComponent {
    private readonly HIGH = 'HIGH';

    reporte: any;

    dataSource: IRegcheqDatasource[] = [];
    displayedColumns: string[] = [
        'ruc',
        'delito',
        'riesgo',
        'fechaInicial',
        'fechaUltimoMov',
    ];

    constructor(private utilsService: UtilsService, @Inject(MAT_DIALOG_DATA) public data: any) {
        this.reporte = data.reporte;
    }

    ngOnInit(): void {
        this.mapRegCheq();
    }

    mapRegCheq() {
        const additionalData = this.reporte?.Reporte?.listas?.secondCriminalCasesChile?.data?.additionalData || [];

        if (additionalData.length === 0) return;

        const withoutDuplicates = [
            ...new Map(
                additionalData.map((item: any) => [item.ruc, item])
            ).values()
        ];

        const filteredData = withoutDuplicates.filter(
            (data: any) => data.riesgo && data.riesgo.toUpperCase().includes(this.HIGH)
        );

        this.dataSource = filteredData?.map((data: any) => {
            const rutElements = filteredData.filter((e: any) => e.ruc == data?.ruc);
            const fechaMasReciente = this.getFecha(rutElements, 'desc');
            const fechaMasAntigua = this.getFecha(rutElements, 'asc');

            return {
                ruc: data.ruc,
                delito: data.crimen,
                riesgo: this.utilsService.riskMapping(data.riesgo),
                fechaInicial: fechaMasAntigua,
                fechaUltimoMov: fechaMasReciente
            }
        });
    }

    getFecha(rutElements: any[], order: 'asc' | 'desc'): string {
        if (!Array.isArray(rutElements) || rutElements.length === 0) {
            return '';
        }

        const elementosValidos = rutElements
            .filter(el => {
                if (!el?.fecha || typeof el.fecha !== 'string') return false;

                const partes = el.fecha.split('/');
                if (partes.length !== 3) return false;

                const [dia, mes, anio] = partes.map((p: any) => parseInt(p, 10));
                if (
                    isNaN(dia) || isNaN(mes) || isNaN(anio) ||
                    dia < 1 || dia > 31 ||
                    mes < 1 || mes > 12 ||
                    anio < 1000
                ) {
                    return false;
                }

                const fechaObj = new Date(anio, mes - 1, dia);
                return !isNaN(fechaObj.getTime());
            })
            .sort((a, b) => {
                const [da, ma, ya] = a.fecha.split('/').map((p: any) => parseInt(p, 10));
                const [db, mb, yb] = b.fecha.split('/').map((p: any) => parseInt(p, 10));

                if (order === 'asc') {
                    return new Date(ya, ma - 1, da).getTime() - new Date(yb, mb - 1, db).getTime();
                } else {
                    return new Date(yb, mb - 1, db).getTime() - new Date(ya, ma - 1, da).getTime();
                }
            });

        return elementosValidos.length > 0 ? elementosValidos[0].fecha : '';
    }
}
